// extracted by mini-css-extract-plugin
export default {"main":"CountryFilter_main__0z94H","list":"CountryFilter_list__tdnMN","card":"CountryFilter_card__BGhW-"};